import { render, staticRenderFns } from "./TwitterPostItemContentsParts.vue?vue&type=template&id=1bc55fd3&scoped=true"
import script from "./TwitterPostItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./TwitterPostItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./TwitterPostItemContentsParts.vue?vue&type=style&index=0&id=1bc55fd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc55fd3",
  null
  
)

export default component.exports